import styled, { RuleSet } from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { DirectionEnum } from '../types';

export const SliderButtonsContainer = styled.div<{ $styles?: RuleSet<object> }>`
  gap: 5px;
  display: none;

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    display: flex;
  }

  ${({ $styles }) => $styles};
`;

export const SliderButton = styled.button<{
  disabled: boolean;
  $direction: DirectionEnum;
}>`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  background-color: transparent;
  background-image: url('/static/images/webview/icon-arrow-left.svg');
  background-size: 18px 10px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};
  transform: ${({ $direction }) =>
    $direction === 'left' ? 'none' : 'rotate(180deg)'};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  transition: opacity 0.2s ease;
`;
